/* eslint-disable */
export const region4bBarangays = [
    {
        CITY: 'ABORLAN',
        BARANGAY: 'APO-APORAWAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'APOC-APOC',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'APORAWAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'BARAKE',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'CABIGAAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'GOGOGNAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'IRAAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'ISAUB',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'JOSE RIZAL',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'MAGBABADIL',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'RAMON MAGSAYSAY',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'SAGPANGAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'TAGPAIT',
    },
    {
        CITY: 'ABORLAN',
        BARANGAY: 'TIGMAN',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'BONO-BONO',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'BULILUYAN',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'CULANDANUM',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'IGANG-IGANG',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'INOGBONG',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'IWAHIG',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'MALIHUD',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'MALITUB',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'MARANGAS',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'MARANGAS (POB.)',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'OCAYAN',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'PURING',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'RIO TUBA',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'SANDOVAL',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'SUMBILING',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'TAGNATO',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'TAGOLANGO',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'TARATAK',
    },
    {
        CITY: 'BATARAZA',
        BARANGAY: 'TARUSAN',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'AMAS',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'ARIBUNGOS',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'BARONG-BARONG',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'CALASAGUEN',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'IMULNOD',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'IPILAN',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'MALIS',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'MAMBALOT',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'ORING-ORING',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'PANGOBILIAN',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'SALOGON',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'SAMARENANA',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'SAMARINANA',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'SARAZA',
    },
    {
        CITY: 'BROOKE\'S-POINT',
        BARANGAY: 'TUBTUB',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'BOGTONG',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'BULUANG',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'CHEEY',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'NEW BUSUANGA',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'NEW BUSUANGA (POB.)',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'OLD BUSUANGA',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'SAGRADA',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BUSUANGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY I',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY IV',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY V',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY VI',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BINTUAN',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'BORAC',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'DECABOBO',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'DECALACHAO',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'MALAWIG',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'MARCILLA',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'CORON',
        BARANGAY: 'TURDA',
    },
    {
        CITY: 'DUMARAN',
        BARANGAY: 'ILIAN',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'ABERAWAN',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BAGONG BAYAN',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BAROTUAN',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BEBELADAN',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BUCANA',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BUENA SUERTE POB.',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'BUENA SUERTE POB. (BARANGAY 2)',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'CORONG-CORONG POB.',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'CORONG-CORONG POB. (BARANGAY 4)',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'MALIGAYA POB.',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'MALIGAYA POB. (BARANGAY 1)',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'MANLAG',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'MASAGANA POB.',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'MASAGANA POB. (BARANGAY 3)',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'PASADENA',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'EL-NIDO',
        BARANGAY: 'VILLA LIBERTAD',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'ANTIPULUAN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'ARAMAYWAN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'BATANG-BATANG',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'BURIRAO',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'CAGUISAN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'CALATEGAS',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'DUMAGUENA',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'ELVITA',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'ESTRELLA VILLAGE',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'IPILAN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'MALATGAO',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'NARRA (POB.)',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'PANACAN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'PANACAN 2',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'PRINCESS URDUJA',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'SANDOVAL',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'TACRAS',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'TARITIEN',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'TERESA',
    },
    {
        CITY: 'NARRA',
        BARANGAY: 'TINAGONG DAGAT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ALFONSO XIII',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ALFONSO XIII (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ARAMAYWAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BERONG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CALATAGBAK',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'ISUGOD',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MALATGAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PANITIAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'PINAGLABANAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'QUINLOGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'SOWANGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'TAGUSAO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BUNOG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CAMPONG ULAY',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CANDAWAGA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CANIPAAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'IRAAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LATUD',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PANALINGAAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PUNTA BAJA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'RANSANG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'TABURI',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ABAROAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ANTONINO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BAGONG BAYAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY 1',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY IV',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY V POB.',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY V POB. (PORAO ISLAND)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARANGAY VI POB.',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CARAMAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DUMARAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'IRAAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'JOLO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MAGARA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MAGARA (ARASAN)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MALCAMPO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MENDOZA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NARRA (MINARA)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NEW BARBACAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NEW BARBACAN (RETAC)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NEW CUYO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'NICANOR ZABALA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SANDOVAL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TARADUNGAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TINITIAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TUMARBONG',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'ALIMANGUAN',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'BINGA',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'CARURAY',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'KEMDENG',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'NEW AGUTAYA',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'NEW CANIPO',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'POBLACION (SAN VICENTE)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'PORT BARTON',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'ABONGAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'ALACALIAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'BANTULAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'BUSY BEES',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'CALAWAG',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'CATABAN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'LIMINANGCONG',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'NEW GUINLO',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'OLD GUINLO',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'PAGLAUM',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'PAMANTOLON',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'PANCOL',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'PULARAQUEN',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'PULARAQUEN (CANIQUE)',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SANDOVAL',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'SILANGA',
    },
    {
        CITY: 'TAYTAY',
        BARANGAY: 'TALOG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BABUYAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG PAG-ASA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG PAG-ASA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG SIKAT (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAGONG SILANG (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BAHILE',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BANCAO-BANCAO',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BARANGAY NG MGA MANGINGISDA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BINDUYAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'INAGAWAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'INAGAWAN SUB-COLONY',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'IRAWAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'IWAHIG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'IWAHIG (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'KALIPAY',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'KALIPAY (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'KAMUNING',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'LANGOGAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'LIWANAG (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'LUCBUAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'LUZVIMINDA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MABUHAY (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MACARASCAS',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MAGKAKAIBIGAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MAGKAKAIBIGAN (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANALO',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANDARAGAT',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANGGAHAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANGGAHAN (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANINGNING',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MANINGNING (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MAOYON',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MARUYOGON',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIGLA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIGLA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIKAP',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIKAP (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIPAG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MASIPAG (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MATAHIMIK',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MATAHIMIK (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MATIYAGA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MATIYAGA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MAUNLAD',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MAUNLAD (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MILAGROSA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MODEL',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'MODEL (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'PAGKAKAISA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'PAGKAKAISA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'PRINCESA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'PRINCESA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SANTA LOURDES',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SEASIDE',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SEASIDE (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'SICSICAN',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TAGBUROS',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TAGUMPAY (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TANABAG',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TANGLAW',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TANGLAW (POB.)',
    },
    {
        CITY: 'PUERTO-PRINCESA',
        BARANGAY: 'TINIGUIBAN',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'ABO-ABO',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'IRARAY',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'ISUMBO',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'LABOG',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PANITIAN',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PULOT CENTER',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PULOT INTERIOR',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PULOT INTERIOR (PULOT II)',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PULOT SHORE',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PULOT SHORE (PULOT I)',
    },
    {
        CITY: 'SOFRONIO-ESPANOLA',
        BARANGAY: 'PUNANG',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'ARMADO',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'BALAO',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'CABACAO',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'LUMANGBAYAN',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'UDALO (CAMURONG)',
    },
    {
        CITY: 'ABRA-DE-ILOG',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'IRIRON',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'MALPALON',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'NEW DAGUPAN',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'POYPOY',
    },
    {
        CITY: 'CALINTAAN',
        BARANGAY: 'TANYAG',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'ARAW AT BITUIN',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'ARAW AT BITUIN (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'BAGONG SIKAT (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'BANAAG AT PAG-ASA',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'BANAAG AT PAG-ASA (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'BINAKAS',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'CABRA',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'LIKAS NG SILANGAN',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'LIKAS NG SILANGAN (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'MAGINHAWA',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'MAGINHAWA (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'MALIIG',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'NINIKAT NG PAG-ASA',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'NINIKAT NG PAG-ASA (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'PARAISO (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'SURVILLE',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'SURVILLE (POB.)',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'TAGBAC',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'TANGAL',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'TILIK',
    },
    {
        CITY: 'LUBANG',
        BARANGAY: 'VIGO',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'BALANSAY',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'FATIMA (TII)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'PAYOMPON',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 1 (BARANGAY 1)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 2 (BARANGAY 2)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 3 (BARANGAY 3)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 4 (BARANGAY 4)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 5 (BARANGAY 5)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 6',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 6 (BARANGAY 6)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 7',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 7 (BARANGAY 7)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 8',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'POBLACION 8 (BARANGAY 8)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'SAN LUIS (LIGANG)',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'TALABAAN',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'TANGKALAN',
    },
    {
        CITY: 'MAMBURAO',
        BARANGAY: 'TAYAMAAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'AGKAWAYAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'AMBIL',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BALIKYAS',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BONBON (POB.)',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BUROL',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'GUITNA',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'GUITNA (POB.)',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'KANLURAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'KANLURAN (POB.)',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'TALAOTAO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'ALIBOG',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CAGURAY',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'CALAWAG',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'GAPASAN',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LASTE',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'NICOLAS',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'NICOLAS (BULO)',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'PACLOLO',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'PURNAGA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'MAGSAYSAY',
        BARANGAY: 'SIBALAT',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ADELA',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'AGUAS',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MAGSIKAP',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MALAWAAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MANOOT',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'RUMBANG',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'AMBULONG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ANSIRAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 1',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 2',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 3',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 4',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 6',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 7',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 8',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BATASAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAYOTBOT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BUBOG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAMBURAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAMINAWIT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CATAYUNGAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CENTRAL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ILING PROPER',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'INASAKAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LA CURVA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LABANGAN ILING',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LABANGAN POBLACION',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAGBAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MANGARIN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAPAYA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MONTE CLARO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MURTHA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'NAIBUAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'NATANDOL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PAWICAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ALACAAK',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BARAHAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CASAGUE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DAYAP',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KURTINGANAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LUMANGBAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MULAWIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PINAGTURILAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PINAGTURILAN (SAN PEDRO)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION I (BARANGAY 1)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION II (BARANGAY 2)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'ALIPAOY',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'BAGONG SILANG POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'BAGONG SILANG POB. (BGY 5)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'HANDANG TUMULONG POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'HANDANG TUMULONG POB. (BGY 2)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'HARRISON',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'LUMANGBAYAN',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'MANANAO',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'MAPALAD POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'MAPALAD POB. (BGY 1)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'MARIKIT',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'PAG-ASA NG BAYAN POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'PAG-ASA NG BAYAN POB. (BGY 4)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'SAN JOSE POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'SAN JOSE POB. (BGY 6)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'SILAHIS NG PAG-ASA POB.',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'SILAHIS NG PAG-ASA POB. (BGY 3)',
    },
    {
        CITY: 'PALUAN',
        BARANGAY: 'TUBILI',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'BATONG BUHAY',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'CLAUDIO SALGADO',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'GENERAL EMILIO AGUINALDO',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'IBUD',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'ILVITA',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'LAGNAS',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'MALISBONG',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'PAETAN',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'POBLACION (LUMANGBAYAN)',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'TUBAN',
    },
    {
        CITY: 'SABLAYAN',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'ALAG',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'BANGKATAN',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'BARAS (MANGYAN MINORITY)',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'BAYANAN',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'BURBULI',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'CATWIRAN I',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'CATWIRAN II',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'DULANGAN I',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'DULANGAN II',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'LANTUYANG',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'LANTUYANG (MANGYAN MINORITY)',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'LUMANG BAYAN',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'MALAPAD',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'MANGANGAN I',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'MANGANGAN II',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'MAYABIG',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'PAMBISAN',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'PULANG-TUBIG',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'PUTICAN-CABULO',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SAN IGNACIO (DULANGAN III)',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SANTA ROSA I',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'SANTA ROSA II',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'TABON-TABON',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'BACO',
        BARANGAY: 'WATER',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'ALCADESMA',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'CONRAZON',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'MALO',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'MANIHALA',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'PROPER BANSUD',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'PROPER TIGUISAN',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'ROSACARA',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'SALCEDO',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'SUMAGUI',
    },
    {
        CITY: 'BANSUD',
        BARANGAY: 'VILLA PAG-ASA',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'ANILAO',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'BAGUMBAYAN I',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'BAGUMBAYAN II',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'BUKAL',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'CAMANTIGUE',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'CARMUNDO',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'FORMON',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'HAGAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'HAGUPIT',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'KALIGTASAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'LABASAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'LABONAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'LISAP',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'MALITBOG',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'MAPANG',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'MASAGUISI',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'MINA DE ORO',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'MORENTE',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'OGBOT',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'ORCONUMA',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'POLUSAHI',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SAGANA',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'SIGANGE',
    },
    {
        CITY: 'BONGABONG',
        BARANGAY: 'TAWAS',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'BALATASAN',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'BENLI',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'BENLI (MANGYAN SETTLEMENT)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'CAMBUNANG',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'CAMBUNANG (POB.)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'CAMPAASAN',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'CAMPAASAN (POB.)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'MAUJAO',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'MILAGROSA (GUIOB)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'NASUKOB',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'NASUKOB (POB.)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN FRANCISCO (ALIMAWAN)',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BULALACAO',
        BARANGAY: 'SAN ROQUE (BUYAYAO)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BALINGAYAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BARUYAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BATINO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BAYANAN I',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BAYANAN II',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BONDOC',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BUCAYAO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BUHUAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'BULUSAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CALERO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CALERO (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CAMANSIHAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CAMILMIL',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CANUBING I',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'CANUBING II',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'COMUNAL',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'GUINOBATAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'GULOD',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'GUTAD',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'IBABA EAST',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'IBABA EAST (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'IBABA WEST',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'IBABA WEST (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'ILAYA (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'LALUD',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'LAZARETO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'LIBIS',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'LIBIS (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'LUMANG BAYAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MAHAL NA PANGALAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MAIDLANG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MALAD',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MALAMIG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MANAGPI',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'MASIPIT',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'NAG-IBA I',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'NAG-IBA II',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'NAVOTAS',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PACHOCA',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PALHI',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PANGGALAAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PATAS',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PERSONAS',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'PUTINGTUBIG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE CENTRAL',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE CENTRAL (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE EAST',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE EAST (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE NORTH',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE NORTH (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE SOUTH',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE SOUTH (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE WEST',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAN VICENTE WEST (POB.)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTA MARIA VILLAGE',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTA RITA (BUNGAHAN)',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SAPUL',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SILONAY',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'SUQUI',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'TAWAGAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'TAWIRAN',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'TIBAG',
    },
    {
        CITY: 'CALAPAN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'AGOS',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'AGSALIN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'ALMA VILLA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'BANUS',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'BANUTAN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'BULAKLAKAN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'BUONG LUPA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'GAUDENCIO ANTONINO',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'GUIMBONAN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'KAWIT',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'LUCIO LAUREL',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MACARIO ADRIATICO',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MALAMIG',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MALAYONG',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MALUBAY',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MANGUYANG',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MARAGOOC',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'MIRAYAN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'PAPANDUNGIN',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'SANTA THERESA',
    },
    {
        CITY: 'GLORIA',
        BARANGAY: 'TAMBONG',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'B. DEL MUNDO',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'BUDBURAN',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'CABALWA',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'DON PEDRO',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'MANAUL',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'PANAYTAYAN',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'ROMA',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'SANTA BRIGIDA',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'VILLA CELESTIAL',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'WASIG',
    },
    {
        CITY: 'MANSALAY',
        BARANGAY: 'WAYGAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ADRIALUNA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ANDRES ILAGAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ANDRES ILAGAN (MAG-ASAWANG TUBIG)',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'APITONG',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ARANGIN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BANCURO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BANUTON',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BARCENAGA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BAYANI',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'CABURO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'EVANGELISTA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'GAMAO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'GENERAL ESCO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'HERRERA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'INARAWAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'KALINISAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'LAGUNA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MAGTIBAY',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MAHABANG PARANG',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MALVAR',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MASAGANA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MASAGUING',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MELGAR A',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MELGAR B',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'METOLZA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MONTELAGO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MONTEMAYOR',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MOTODERAZO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'MULAWIN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'NAG-IBA I',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'NAG-IBA II',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PAGKAKAISA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PANIQUIAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PINAGSABANGAN I',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PINAGSABANGAN II',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'PINAHAN',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION I (BARANGAY I)',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION II (BARANGAY II)',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'POBLACION III (BARANGAY III)',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN AGUSTIN I',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN AGUSTIN II',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'NAUJAN',
        BARANGAY: 'TIGKAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CANTIL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DANGAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'HAPPY VALLEY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LITTLE TANAUAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MARASKA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'PACLASAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'PACLASAN (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN AQUILINO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'UYAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'BAGSOK',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'BATONG DALIG',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'BAYUIN',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'BUGTONG NA TUOG',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'CALOCMOY',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'CALUBAYAN',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'CATININGAN',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'FORTUNA',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'HAPPY VALLEY',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'LEUTEBORO I',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'LEUTEBORO II',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MA. CONCEPCION',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MABUHAY I',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MABUHAY II',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MALUGAY',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MATUNGAO',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'MONTEVERDE',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'PASI I',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'PASI II',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SANTO DOMINGO (LAPOG)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SUBAAN',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'VILLAREAL',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'VILLAREAL (DAAN)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE I',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE II',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE III',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE IV',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ALCATE',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ANTONINO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BABANGONAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BAMBANIN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BETHEL',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CANAAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'DUONGAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'JOSE LEIDO JR.',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'LOYAL',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MACATOC',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MALABO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MERIT',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ORDOVILLA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'PAKYAS',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN GELACIO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN NARCISO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'URDANETA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'VILLA CERVEZA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ANOLING',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'CACAWAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'CALINGAG',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'DEL RAZON',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'GUINHAWA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'INCLANAY',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'LUMANGBAYAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'MALIANGCOG',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'MANINGCOL',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'MARAYOS',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'MARFRANCISCO',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'NABUSLOT',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PAGALAGALA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PALAYAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PAMBISAN MALAKI',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PAMBISAN MUNTI',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PANGGULAYAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PAPANDAYAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'QUINABIGAN',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'RANZO',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE I',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE II',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE III',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE IV',
    },
    {
        CITY: 'PINAMALAYAN',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BACAWAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BACUNGAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BATUHAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BAYANAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'BUHAY NA TUBIG',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'CALIMA',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'CALUBASANHON',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'CAMPAMENTO',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'CASILIGAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'MALUANLUAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'MATULATULA',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'MISONG',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'PAHILAHAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'PANIKIHAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'PUTING CACAO',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'TAGBAKIN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'TAGUMPAY',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'TIGUIHAN',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'ZONE I',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'ZONE II',
    },
    {
        CITY: 'POLA',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'ANINUAN',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'BACLAYAN',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'BALATERO',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'PALANGAN',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'SINANDIGAN',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'TABINAY',
    },
    {
        CITY: 'PUERTO-GALERA',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'BIGAAN',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'CAAGUTAYAN',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'CALANGATAN',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'CALSAPA',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'ILAG',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'LUMANGBAYAN',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-TEODORO',
        BARANGAY: 'TACLIGAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'AGOT',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'AGUMAYMAYAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'AMOINGON',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'APITONG',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BALAGASAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BALARING',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BALIMBING',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BANGBANGALON',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BANTAD',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BAYUTI',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BINUNGA',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BOI',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BOTON',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BULIASNIN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'BUNGANAY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'CAGANHAO',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'CANAT',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'CATUBUGAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'DAIG',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'DAYPAY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'DUYAY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'HINAPULAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'IHATUB',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'ISOK I',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'ISOK I (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'ISOK II POB.',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'ISOK II POB. (KALAMIAS)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'LAYLAY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'LUPAC',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MAHINHIN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MALUSAK',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MALUSAK (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MANSIWAT',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MATAAS NA BAYAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MATAAS NA BAYAN (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MAYBO',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MERCADO',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MERCADO (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MURALLON',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'MURALLON (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'OGBAC',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'POCTOY',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'PORAS',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'PUTING BUHANGIN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'PUYOG',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'SABONG',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'SAWI',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TABI',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TABIGUE',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TAGWAK',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TAMBUNAN',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TAMPUS',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TAMPUS (POB.)',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TUGOS',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TUMAGABOK',
    },
    {
        CITY: 'BOAC',
        BARANGAY: 'TUMAPON',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BACHAO IBABA',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BACHAO ILAYA',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BACONGBACONG',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BANOT',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BANUYO',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY I',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'BOGNUYAN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'DILI',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'LIBTANGIN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'MAHUNIG',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'MANGILIOL',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'MASIGA',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'MATANDANG GASAN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'PINGAN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'TABIONAN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'TAPUYAN',
    },
    {
        CITY: 'GASAN',
        BARANGAY: 'TIGUION',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BAGTINGON',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY I',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY IV',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BICAS-BICAS',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CAIGANGAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DAYKITIN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SIHI',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TIMBO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TIMBO (SANGGULONG)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TUNGIB-LIPATA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'YOOK',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ALOBO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ANGAS',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'ATURAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAGONG SILANG POB.',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAGONG SILANG POB. (2ND ZONE)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAGUIDBIRIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BALIIS',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANAHAW POB.',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANAHAW POB. (3RD ZONE)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANGCUANGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANOGBOG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BOTILAO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BUYABOD',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DATING BAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DEVILLA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'HAGUIMIT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'HUPI',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'JOLO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KAGANHAO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KALANGKANG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KAMANDUGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KASILY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KILO-KILO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'KINAMAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LABO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LAMESA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LANDY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LAPU-LAPU POB.',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LAPU-LAPU POB. (5TH ZONE)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LIPA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LUSOK',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MAHARLIKA POB.',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MAHARLIKA POB. (1ST ZONE)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MAKULAPNIT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MANIWAYA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MANLIBUNAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MASAGUISI',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MASALUKOT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MATALABA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MONGPONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MORALES',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PAG-ASA POB.',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PAG-ASA POB. (4TH ZONE)',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PANTAYIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PULONG-PARANG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAGUM',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAMAYO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAMBANGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAWIRAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'ANAPOG-SIBUCAO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'ARGAO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'BALANACAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'BANTO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'BINTAKAY',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'BOCBOC',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'BUTANSAPA',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'CANDAHON',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'CAPAYANG',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'DULONG BAYAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'DULONG BAYAN (POB.)',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'GITNANG BAYAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'GITNANG BAYAN (POB.)',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'GUISIAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'HINADHARAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'HINANGGAYON',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'INO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'JANAGDONG',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'LAMESA',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'LAON',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MAGAPUA',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MALAYAK',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MALUSAK',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MAMPAITAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MANGYAN-MABABAD',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MARKET SITE',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MARKET SITE (POB.)',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MATAAS NA BAYAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'MENDEZ',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'NANGKA I',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'NANGKA II',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'PAYE',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'PUTING BUHANGIN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'SAYAO',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'SUMANGGA',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'TARUG',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'VILLA MENDEZ',
    },
    {
        CITY: 'MOGPOG',
        BARANGAY: 'VILLA MENDEZ (POB.)',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'BANGWAYIN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'BAYAKBAKIN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'BONLIW',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'BUANGAN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'CABUYO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'CAGPO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'DAMPULAN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'KAY DUKE',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MAKAWAYAN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MARANLIG',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MARLANGGA',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'MATUYATUYA',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'PAKASKASAN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'PAYANAS',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'POCTOY',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'SIBUYAO',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'SUHA',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'TALAWAN',
    },
    {
        CITY: 'TORRIJOS',
        BARANGAY: 'TIGWI',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'BANICE',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'HAMBI-AN',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'LAGANG',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'NABALAY',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'NASUNOGAN',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'SIBAY',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TAN-AG',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TOCTOC',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TOGBONGAN',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TOGONG',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TUMALUM',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'TUNGONAN',
    },
    {
        CITY: 'BANTON',
        BARANGAY: 'YABAWON',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'ALIBAGON',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'CAMBAJAO',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'CAMBALO',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'CAMBIJANG',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'CANTAGDA',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'GUTIVAN',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'LICO',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'LUMBANG ESTE',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'LUMBANG WESTE',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'MARIGONDON',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'CAJIDIOCAN',
        BARANGAY: 'TAGUILOS',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'AMBULONG',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'COLONGCOLONG',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'GOBON',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'GUINTIGUIBAN',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'ILIJAN',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'MAHABA',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'MANGANSAG',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CORCUERA',
        BARANGAY: 'TACASAN',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'AGNONOC',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'BUNSORAN',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'CLARO M. RECTO',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'HINAGUMAN',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'POBLACION (FERROL)',
    },
    {
        CITY: 'FERROL',
        BARANGAY: 'TUBIGON',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'AGSAO',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'AGUTAY',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'AMBULONG',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'JAO-ASAN',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'SILUM',
    },
    {
        CITY: 'MAGDIWANG',
        BARANGAY: 'TAMPAYAN',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'AMATONG',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'ANAHAO',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'BATIANO',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'BUDIONG',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'CANDUYONG',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'DAPAWAN',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'GABAWAN',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIGAYA (POB.)',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIWANAG (POB.)',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIWAYWAY',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'LIWAYWAY (POB.)',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'MALILICO',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'MAYHA',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'PANIQUE',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'PATO-O',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'POCTOY',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'PROGRESO ESTE',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'PROGRESO WESTE',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TABING DAGAT',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TABING DAGAT (POB.)',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TABOBO-AN',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'ODIONGAN',
        BARANGAY: 'TUMINGAD',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGBALUTO',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGBUDIA',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGNAGA',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGNAY',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGNIPA',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGPANABAT',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'AGTONGO',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'ALAD',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY I',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY II',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY III',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY IV',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'CAJIMOS',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'CALABOGO',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'CAPACLAN',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'COBRADOR',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'GINABLAN',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'GUIMPINGAN',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'ILAURAN',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'LAMAO',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'LI-O',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'LOGBON',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'LONOS',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'LUNAS',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'MACALAS',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'MAPULA',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'PALJE',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'SABLAYAN',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'ROMBLON',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'BAGSIK',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'BONLAO',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CALAGONSAO',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CAMILI',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CAMOD-OM',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'GUI-OB',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'LAWAN',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'MADALAG',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'TUGDAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PAGSANGAHAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PANGULO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BACHAWAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CALABASAHAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'DALAJICAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MASADYA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MASUDSUD',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAMPONG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'AGOJO',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BALATUCAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'CAMANDAO',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'GUINHAYAAN',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'LIMON NORTE',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'LIMON SUR',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'MANHAC',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'LOOC',
        BARANGAY: 'TUGUIS',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BACHAWAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BINONGAHAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BINUGUSAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CABOLUTAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CAGBUAYA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CAMANTAYA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DONA JUANA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DUBDUBAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'LUSONG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MAHABANG BAYBAY',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MAHABANG BAYBAY (LONG BEACH)',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'AGPUDLOS',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'CALUNACON',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'DONA TRINIDAD',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'JUNCARLO',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'LINAWAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MARIGONDON NORTE',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MARIGONDON SUR',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'MATUTUNA',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'PAG-ALAD',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'TAN-AGAN',
    },
    {
        CITY: 'SAN-ANDRES',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'AGTIWA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'AZARGA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CAMPALINGO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CANJALON',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ESPANA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MABULO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'OTOD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PANANGCALAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TACLOBO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'COMBOT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PINAMIHAGAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'AGMANIC',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'CANYAYO',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'DANAO NORTE',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'DANAO SUR',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'GUINBIRAYAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'GUINTIGBASAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'MAT-I',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CONCEPCION NORTE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CONCEPCION NORTE (POB.)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CONCEPCION SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PAROYHOG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SANTO NINO',
    }
];
